module.exports = __webpack_public_path__ + "img/home_narrow_combo_normal.64c0316d.svg";